import { ArrowUpRight, Shirt } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PARTNER_URL = "https://www.tpprintestamparia.com/";
const IMAGE =
  "https://images.unsplash.com/photo-1755018097060-682f291aad30?crop=entropy&cs=srgb&fm=jpg&w=900&q=80";

export const PartnerBanner = () => (
  <aside className="mx-auto w-full max-w-5xl px-5">
    <div className="flex items-center gap-3 pb-2">
      <span className="text-[10px] uppercase tracking-[0.28em] text-neutral-400">
        Publicidade
      </span>
      <span className="h-px flex-1 bg-neutral-200" />
    </div>

    <Reveal y={18}>
      <a
        href={PARTNER_URL}
        target="_blank"
        rel="noopener noreferrer sponsored"
        data-testid="partner-banner-tpprint"
        aria-label="Quero a camiseta pronta — visitar TP Print Estamparia"
        className="group grid overflow-hidden rounded-2xl border border-neutral-200 bg-black transition-shadow duration-300 hover:shadow-[0_24px_50px_-28px_rgba(0,0,0,0.7)] sm:grid-cols-[1fr_260px]"
      >
        <div className="relative p-6 sm:p-8">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#f58244] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-white">
            <Shirt className="h-3.5 w-3.5" strokeWidth={2.6} />
            Camiseta pronta
          </span>
          <p className="mt-4 text-xl font-extrabold leading-tight text-white sm:text-2xl">
            Quer mais do que a impressão? Receba a{" "}
            <span className="text-[#f58244]">camiseta completa</span>, já
            estampada e pronta para vender.
          </p>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/60">
            A TP Print Estamparia cuida de tudo: camiseta, aplicação da estampa
            e acabamento. É só clicar e falar com eles.
          </p>
          <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-[#f58244]">
            Clique aqui e peça sua camiseta pronta
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={2.6} />
          </span>
        </div>

        <div className="relative h-36 overflow-hidden sm:h-full">
          <img
            src={IMAGE}
            alt="Camiseta personalizada pronta com estampa aplicada"
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
          />
          <span className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/70 via-black/10 to-transparent sm:bg-gradient-to-r sm:from-black sm:via-black/20 sm:to-transparent" />
        </div>
      </a>
    </Reveal>
  </aside>
);
